import React from 'react';
import AdminView from './views/AdminView';
import FactoryView from './views/FactoryView';
import CustomerView from './views/CustomerView';

interface User {
  _id: string;
  role: 'admin' | 'developer' | 'factory' | 'support' | 'technician' | 'customer';
  firstName: string;
  lastName: string;
  email: string;
}

interface DashboardProps {
  user: User;
  onLogout: () => void;
}

const Dashboard: React.FC<DashboardProps> = ({ user, onLogout }) => {
  const usesAdminShell = ['admin', 'developer', 'technician', 'support'].includes(user.role);
  const shellClass = usesAdminShell ? 'admin-dashboard-shell' : undefined;

  return (
    <div className={shellClass}>
      {usesAdminShell && <AdminView user={user} onLogout={onLogout} />}
      {user.role === 'factory' && <FactoryView user={user} onLogout={onLogout} />}
      {user.role === 'customer' && <CustomerView user={user} onLogout={onLogout} />}
    </div>
  );
};

export default Dashboard;
